import * as React from "react";
const TrashIcon = ({width = "24px", height = "24px", color = "#000000", ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    style={{
      enableBackground: "new 0 0 24 24",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path
        fill={color}
        d="M20.2,6.2H3.8c-0.6,0-1-0.4-1-1s0.4-1,1-1h16.5c0.6,0,1,0.4,1,1S20.8,6.2,20.2,6.2z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M9.8,16.8c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v6C10.8,16.3,10.3,16.8,9.8,16.8z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M14.2,16.8c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v6C15.2,16.3,14.8,16.8,14.2,16.8z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M18,21.2H6c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.2V5.2c0-0.6,0.4-1,1-1s1,0.4,1,1v14h11.5v-14 c0-0.6,0.4-1,1-1s1,0.4,1,1v14.2c0,0.5-0.2,0.9-0.5,1.2C18.9,21.1,18.5,21.2,18,21.2z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M15.8,6.2c-0.6,0-1-0.4-1-1V3.8c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1H9.8c-0.1,0-0.3,0.1-0.4,0.1 C9.3,3.5,9.2,3.6,9.2,3.8v1.5c0,0.6-0.4,1-1,1s-1-0.4-1-1V3.8C7.2,3.1,7.5,2.5,8,2s1.1-0.7,1.8-0.7h4.5c0.7,0,1.3,0.3,1.8,0.7 c0.5,0.5,0.7,1.1,0.7,1.8v1.5C16.8,5.8,16.3,6.2,15.8,6.2z"
      />
    </g>
  </svg>
);
export default TrashIcon;
